import moment from "moment";
import {useTranslation} from "react-i18next";

function getDateFormat(date, t){

    let m  = moment.utc(date);
    let today = moment.utc();
    let d = today.unix() - m.unix() ;
    let ago = {label : 'h', v : "hours"};

    if(d<60){
        ago = {label : 's', v : "seconds"};
    }else if (d<3600){
        ago = {label : 'min', v : "minutes"};
    }else if (d<86400){
        ago = {label : 'h', v : "hours"};
    }else if(d<604800){
        ago = {label : t('d'), v : "days"};
    }else{
        ago = false;
    }

    let diff, formatted;
    if (ago !== false) {
        diff = today.diff(m, ago.v);
        formatted = diff + " " + ago.label;
    } else {
        formatted = diff = m.local().format("DD/MM/Y");
    }

    return {value: diff, unit: ago, formatted};
}

export const PostDate = ({date}) =>{
  const { t } = useTranslation();

  const fd = getDateFormat(date, t);

  const date_str = fd.unit ? t("date_ago", { date: fd.value + fd.unit.label }) : fd.formatted;

  return <div className={'postDate'}>{ date_str }</div>
}
